import { userFunctions } from "services/user_management/user_management.types";
import { Pagination, SimpleEntity } from "types/globals";

// CLIENT HUB
export interface ClientHubResponse {
    results: ClientHub[];
    meta: Pagination;
}

export interface ClientHub {
    id: number;
    name: string;
    sub_orgs: ClientHub[];
    roles_ld: SimpleEntity[];
    roles_pace: SimpleEntity[];
    users_count: number;
    users_count_org_admin: number;
    users_count_roles: UsersCountRole[];
    users: SimpleEntity[];
    crm_id: null;
    crm_url: null;
    created_utc: Date;
}

export interface UsersCountRole {
    ORG_ADMIN_SUPER?: number;
    ORG_ADMIN_BASIC?: number;
}

// CLIENT HUB BY ORG ID
export interface ClientHubByIdResponse {
    id: number;
    name: string;
    group: SimpleEntity;
    created_utc: Date;
    sub_orgs: any[];
    roles_ld: SimpleEntity[];
    roles_pace: SimpleEntity[];
    users_count: number;
    users_count_org_admin: number;
    users_count_roles: UsersCountRole[];
    users: SimpleEntity[];
    crm_id: null;
}

export interface UsersCountRole {
    ORG_ADMIN_SUPER?: number;
    ORG_ADMIN_BASIC?: number;
}

// CLIENT HUB BY ORG ID USERS
export interface ClientHubUsersResponse {
    results: ClientHubUser[];
    meta: Pagination;
}

export interface ClientHubUser {
    id: number;
    name: string;
    username: string;
    email: string;
    job_title: string;
    job_company_name: string;
    last_active_datetime: Date;
    person: ClientHubUsersPerson;
    roles: Role[];
    function: { name: userFunctions };
    group_functions: {
        group_id: number;
        function: {
            name: string;
        };
    }[];
}

export interface ClientHubUsersPerson {
    id: number | null;
    name: string | null;
    linkedin_id: string | null;
}

// NEW CLIENT HUB RESPONSE
export interface ClientHubCreationPayload {
    name: string;
    company_id: number;
    pay_wall_role_masks: string[];
}
export interface ClientHubCreationResponse {
    id: number;
    name: string;
    group: Group;
    created_utc: Date;
    sub_orgs: any[];
    roles_ld: Group[];
    roles_pace: Group[];
    users_count: number;
    users_count_org_admin: number;
    users_count_roles: UsersCountRole[];
    users: any[];
    crm_id: null;
}

export interface Group {
    id: number;
    name: string;
}

export interface UsersCountRole {
    ORG_ADMIN_BASIC?: number;
    ORG_ADMIN_SUPER?: number;
}

// HUB USERS TO ADD
export interface UsersCanAddResponse {
    results: UsersCanAddList[];
    meta: Pagination;
}

export interface UsersCanAddOrg {
    id: number;
    name: string;
    company_id: number;
    crm_id: number | null;
}
export interface UsersCanAddList {
    id: number;
    name: null | string;
    username: string;
    email: string;
    job_title: null | string;
    job_company_name: null | string;
    last_active_utc: Date | null;
    orgs: UsersCanAddOrg[];
    person: {
        id: number | null;
        linkedin_id: string | null;
        name: string | null;
    };
}

// PERMISSIONS REF
export interface PermissionsRefResponse {
    roles: PermissionsRef[];
}

export interface PermissionsRef {
    id: number;
    name: string;
    label: null | string;
    description: null | string;
    flags: PermissionsRefFlag[];
}

export interface PermissionsRefFlag {
    name: Name;
}

export enum Name {
    IsLd = "IS_LD",
    IsPace = "IS_PACE",
}

// PERMISSIONS REF BUNDLES
export interface RoleBundleResponse {
    bundles: RoleBundle[];
}
export interface RoleBundle {
    name: string;
    label: string;
    description: string;
    roles: Role[] | [];
    user_functions: UserFunction[];
}
export interface Role {
    id: number;
    name: string;
}

export interface UserFunction {
    name: UserRole;
    roles: Role[];
}

export enum UserRole {
    Admin = "ADMIN",
    Profile = "PROFILE",
    ViewEdit = "VIEW_EDIT",
    ViewOnly = "VIEW_ONLY",
}
